import { generateSkinDefaults } from '@wix/editor-elements-panel';

import type { SiteAssetsSkinParams } from '../TextEffectsShared/TextEffectsShared.skinParams';
import { textEffectsSharedSkin } from '../TextEffectsShared/TextEffectsShared.skinParams';

export const TextEffects3dSkin = {
  ...textEffectsSharedSkin,
  'text-stroke': {
    type: 'NUMBER',
    defaultValue: '4',
  },
  'text-stroke-color': {
    type: 'COLOR',
    defaultValue: '#000000',
  },
  'text-stroke-opacity': {
    type: 'ALPHA',
    defaultValue: '1',
  },
  'text-shadow-1': {
    type: 'CSSString',
    defaultValue: '0px 0px 0px #000000',
  },
  'text-shadow-2': {
    type: 'CSSString',
    defaultValue: '0px 0px 0px #000000',
  },
  'text-shadow-3': {
    type: 'CSSString',
    defaultValue: '0px 0px 0px #000000',
  },
  'fill-color': {
    type: 'COLOR',
    defaultValue: '#000000',
  },
  'fill-opacity': {
    type: 'ALPHA',
  },
} as const satisfies SiteAssetsSkinParams;

const TextEffects3dSkinDefinitionMap: Record<string, SiteAssetsSkinParams> = {
  'wixui.skins.TextEffects3d': TextEffects3dSkin,
};

export default generateSkinDefaults(TextEffects3dSkinDefinitionMap);
